import React from 'react';
import { Button, createStyles, Grid, Icon, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import {useDropzone} from 'react-dropzone';

import { HomeContext } from '../../Features/Home/HomeContext';

interface IBasicDropzoneProps {
    onChangefile: (file: File) => void,
    isClipperSpreadsheetUpload: boolean,
    isInfluencerSpreadsheetUpload?:boolean,
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        borderStyle: 'dashed',
        borderRadius: '8px',
        width: '400px',
        heightMax: '240px',
        borderColor: '#DBDBDB',
        padding: '10px',
    },
    itens: {
        textAlign: 'center',
        wordBreak: 'break-word',
        margin: '8px',        
    },
    icon: {
        margin: '8px',      
        fontSize: '60px'
    },
    button: {
        margin: '8px',      
        border: '1px solid ',
        borderColor: theme.palette.primary.dark
    }
}));


export function BasicDropzone({onChangefile, isClipperSpreadsheetUpload,isInfluencerSpreadsheetUpload}: IBasicDropzoneProps ) {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);

    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({accept: '.xls,.xlsx' });

    React.useEffect(() => {
        if (fileRejections.length > 0) {
            if (fileRejections[0].errors[0].code === 'file-invalid-type') {
                homeContext.showWarning('O formato inserido não é válido. Por favor, insira uma planilha em um dos formatos permitidos.');
            } else {
                homeContext.showError('Ocorreu um erro e não foi possível concluir o upload. Por favor, tente novamente.');
            }
        }
    },[fileRejections]);

    React.useEffect(() => {
        if (acceptedFiles.length > 0) {
            onChangefile(acceptedFiles[0]);
        }
    }, [acceptedFiles]);

    return (
        <>
            <section className="container">
                <Paper elevation={0} className={classes.container}>
                    <div  {...getRootProps({className: 'dropzone'})}>
                        <input {...getInputProps()} />
                        { acceptedFiles.length == 0 && (
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="center"
                            >
                                <Icon className={classes.icon} color="primary">backup</Icon>
                                <Typography variant="body1" className={classes.itens}>
                                    {isInfluencerSpreadsheetUpload
                                        ? 'ARRASTE E SOLTE A PLANILHA'
                                        : `ARRASTE E SOLTE A PLANILHA ${isClipperSpreadsheetUpload ? 'DA CLIPADORA' : 'DO STILINGUE'}`
                                    }
                                </Typography>
                                <Typography variant="caption" className={classes.itens}>
                                    ou se preferir...
                                </Typography>
                                <Button variant="outlined" className={classes.button}  >
                                    SELECIONE UM ARQUIVO
                                </Button>
                                <Typography variant="caption" className={classes.itens}>
                                    .xls ou .xlsx
                                </Typography>
                            </Grid>
                        )}
                        { acceptedFiles.length > 0 && (
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="center"
                            >                            
                                <Typography variant="body1" className={classes.itens}>
                                    Sua planilha foi carregada com sucesso!
                                </Typography>
                                <Icon className={classes.icon} color="primary">done</Icon>
                                <Typography variant="subtitle1" className={classes.itens}>
                                    {acceptedFiles[0].name}
                                </Typography>
                                <Button variant="outlined" className={classes.button} >
                                    TROCAR PLANILHA
                                </Button>                            
                            </Grid>
                        )}                    
                    </div>
                </Paper>            
            </section>
        </>
    );
}
